import { PASSWORD_MIN_LENGTH } from '@teentack/shared';

/**
 * Scoring lives apart from the meter component so the file that renders it
 * only exports a component — the same split as `button-styles.ts`.
 */
export interface PasswordStrength {
  score: 0 | 1 | 2 | 3 | 4;
  label: string;
  tone: string;
}

export const STRENGTH_TONES = [
  'bg-slate-200',
  'bg-red-500',
  'bg-sun-500',
  'bg-brand-500',
  'bg-safe-500',
] as const;

const LABELS = ['Too short', 'Weak', 'Fair', 'Good', 'Strong'] as const;

/**
 * A hint, not a gate — the api enforces the real policy. It rewards length
 * first, because length is what actually makes a password hard to guess.
 */
export function scorePassword(value: string): PasswordStrength {
  if (value.length < PASSWORD_MIN_LENGTH) {
    return { score: 0, label: LABELS[0], tone: STRENGTH_TONES[0] };
  }

  let points = 1;
  if (value.length >= 16) points += 1;
  const classes = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^A-Za-z0-9]/].filter((re) => re.test(value)).length;
  if (classes >= 3) points += 1;
  if (classes === 4 && value.length >= 14) points += 1;

  const score = Math.min(points, 4) as 1 | 2 | 3 | 4;
  return { score, label: LABELS[score], tone: STRENGTH_TONES[score] };
}
